/**
 * The signer's inbox — everything waiting on this person's signature, across
 * both signing engines.
 *
 * Deliberately a Core route (`/to-sign`), not a tab under `/esign`. The eSign
 * module owns the `/esign` prefix, so App wraps it in ModuleUpsellPage for any
 * tenant that has not bought the add-on. That meant an employee whose company
 * never bought eSign clicked the nav item literally labelled "To Sign" and was
 * shown a sales page instead of the employment contract awaiting their
 * signature — with the upsell copy cheerfully noting "Offer letters and HR
 * letters already sign without this".
 *
 * HR Letters are Core. The place you go to sign one has to be Core too.
 *
 * Spec: .claude/specs/letters-esignature-parity-with-offers.md (Package G, AC30)
 */
import React from "react";

import { ToSignTab } from "./EsignPage";

export default function ToSignPage() {
  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: "0 0 4px", fontSize: 22, color: "#0f172a" }}>To Sign</h1>
        <p style={{ margin: 0, fontSize: 13, color: "#64748b" }}>
          Everything waiting for your signature, including HR letters and contracts.
        </p>
      </div>
      <ToSignTab />
    </div>
  );
}
